import React, { Component } from "react";

import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { reduxForm, Form, Field } from "redux-form";

import Table from "rc-table";
import "rc-table/assets/index.css";

import { setLoading, reset, initializeForm } from "../../../../helpers/redux";
import { dateFormat2Show, dateFormat2Save } from "../../../../helpers/dataTransformers";

import { InputLabel } from "../../../../common/components/form/fields";
import Button from "../../../../common/components/ui/button/button";
import ItemChart from "../../../../common/components/itemChart/itemChart";
import Loading from "../../../../common/components/ui/loading/loading";

import { remove, getListFiltered as getMyCharts, update, create } from "./myChartsActions";
import {
    getListFiltered as getMyCategories, create as createCategory,
    remove as removeCategory
} from "../../../admin/pages/category/categoryActions";

import { drawChart, saveChart } from "../home/homeActions";
import types from "./myChartsTypes";
import fields from "./form/fields";
import { ErrorModal } from "../../../../common/components/ui/modals";
import DefaultModal from "../../../../common/components/ui/modals/defaultModal/defaultModal";

import EnhancedSwitch from 'react-icheck/lib/EnhancedSwitch';
import { RadioGroup, Radio } from "react-icheck";
import "icheck/skins/all.css";
import axios from "axios";
import { USER_TOKEN, BASE_API } from "../../../../config/consts";

EnhancedSwitch.propTypes = {
    ...EnhancedSwitch.propTypes,
    cursor: PropTypes.any,
    checked: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
}

let categories = [
    {name: 'Todos', _id: ""}
];

const categoriesColumns = [
	{
		title: "Nome",
		dataIndex: "name",
		key: "name",
	}
];

const URL = `${BASE_API}/cities/`;


const fieldsAPI = "name,person_name,hour,daylight_savings,birthday,city.lat,city.lon,city.timezone,user,category";

class MyCharts extends Component {
    constructor(props) {
        super(props);
        this.props.setLoading(types.MY_CHARTS_LOADING, true);
        this.props.getMyCharts(this.props.auth.user._id, fieldsAPI, 'limit=999999');
        this.props.getMyCategories(this.props.auth.user._id, 'limit=999999');
        this.state = {
            search: '',
            category: '',
            newCategory: '',
            item: null,
            titleModal: 'Novo mapa',
            errVisible: false,
            isVisible: false,
            isVisibleCat: false,
            visibleSelect: false,
            updated: false
        };
        this.searchInput = null
    }


    onSubmit = values => {
        
        const newValues = {
            ...values,
            person_name: values.person_name.trim(),
            name: values.name.trim(),
            city: values.city.item,
            birthday: dateFormat2Save(values.birthday, "/"),
            user: this.props.auth.user._id,
            daylight_savings: values.daylight_savings ? values.daylight_savings : false
        };

        if (values.category){
            newValues['category'] = values.category.value
        }
        if (values._id) {
            this.props.update(newValues);
        } else {
            this.props.create(newValues);
        }
        this.closeForm();

    };

    closeForm = () => {
        this.setState({
            isVisible: false,
            item: null
        });
        setTimeout(() => {
            this.props.reset("myChartsForm");
        }, 1000);
    };

    changeSearch = (e) => {
        this.setState({
            search: e.target.value
        })
    }

    changeNewCategory = (e) => {
        this.setState({
            newCategory: e.target.value
        })
    }

    handleKeyDowNewCategory = (e) => {
        if (e.key === 'Enter') {
            this.handleAddCategory();
        }
    }

    changeRadio = (e) => {
        this.setState({
            category: e.target.value
        });
        const filter = e.target.value === "" ? "" : `category=${e.target.value}&limit=999999`;
        this.props.getMyCharts(this.props.auth.user._id, fieldsAPI, filter);
    }

    clearSearch = (e) => {
        this.changeSearch({target: {value: ''}});
    }

    handleEdit = (item) => {
        const city = item.city;
        const category = item.category ? {
            label: item.category.name,
            value: item.category._id
        } : undefined;
        const formValues = {
            ...item,
            birthday: dateFormat2Show(item.birthday, '/'),
            city: {
                label: city.name + ` - ${city.state ? city.state.name+' - ' : ''}`+ city.country_letters,
                value: city._id
            },
            category
        }
        this.props.reset("myChartsForm");
        this.setState({
            isVisible: true,
            titleModal: "Editar mapa "+ item.name
        });
        this.props.initializeForm('myChartsForm', formValues);
    }

    confirmDelete = (item) => {
        this.setState({
            errVisible: true,
            item
        });
    }
    
    hideDelete = () => {
        this.setState({
            errVisible: false,
            item: null
        });
    }

    handleDelete = () => {
        this.props.remove(this.state.item);
        this.hideDelete();
    }

    handleAddCategory = () => {
        this.props.createCategory(
            {name: this.state.newCategory, owner: this.props.auth.user._id},
            undefined,
            this.props.auth.user._id
        );
        this.setState({
            newCategory: ''
        });
    }

    handleDeleteCategory = (item) => {
        this.props.removeCategory(item, undefined, this.props.auth.user._id);
    }

    promiseOptions = inputValue => {
        let filterValues = "country_letters(BR)"
        if (inputValue !== "") {
            if(inputValue.split("-").length > 1){
                filterValues = `name(^${inputValue.split("-")[0].trim()}),country_letters(${inputValue.split("-")[1].trim()})`
            } else {
                filterValues = `name(^${inputValue})`
            }
        }
        return axios.get(`${URL}?limit=50&like=${filterValues}&sort=name[asc]&populate=state`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(localStorage.getItem(USER_TOKEN)).token}`
            }
        }).then((response) => {
            let listCities = [];
            listCities = response.data.content.map(item => ({
                label: item.name + ` - ${item.state ? item.state.name+' - ' : ''}`+ item.country_letters,
                value: item._id,
                item: item
            })
            )
            return listCities;

        }).catch((err) => {
            console.log(err)
            return null
        })
    };


    renderOptionsCategories = () => {
        return this.props.categories.map(item => ({
            label: item.name,
            value: item._id
        }));
    };

    renderFields = () => {
        return fields(this.promiseOptions, this.renderOptionsCategories).map(
            (item, index) => <Field {...item} key={index} />
        );
    };

    renderColumns = () => {
		const { Column } = Table;
		const headers = categoriesColumns.map((item, index) => (
			<Column className="table__column" {...item} key={index} />
		));

		headers.push(
			<Column
				title="Ações"
				dataIndex="actions"
				className="table__column"
				key={headers.length}
				render={(text, record) => (
					<div style={{cursor: 'pointer', padding: '0 1rem'}} onClick={() => this.handleDeleteCategory(record)}>
						<i className="fa fa-trash-o" style={{ fontSize: '1.6rem', color: 'red'}} />
						<span style={{display: 'none'}}>Excluir</span>
					</div>
				)}
			/>
		);

		return headers;
	}

    renderCategories = () => {
        const newcategories = categories.concat(this.props.categories);
        return newcategories.map((item, index) => (
            <Radio
                key={index}
                value={item._id}
                radioClass="iradio_square-blue"
                increaseArea="20%"
                cursor='false'
                label={<span style={{fontSize: '1.6rem', verticalAlign: 'middle'}}>{item.name}</span>}
            />
        ))
    }

    renderMyCharts = () => {
        return this.props.myCharts.map((item, index) => (
            <ItemChart
                key={index}
                item={item}
                onDelete={this.confirmDelete}
                onEdit={this.handleEdit}
            />
        ));
    }

    renderForm = () => {
        const { handleSubmit } = this.props;
        return (
            <div className="modal-body center-text" style={{ paddingTop: 20 }}>
                <Form role="form" onSubmit={handleSubmit(this.onSubmit)} noValidate>
                    <div className="form__body">{this.renderFields()}</div>
                    <div className="form__footer">
                        <div className="form__footer--actions">
                            <Button
                                text="Cancelar"
                                type="button"
                                rounded
                                colors={"#f1c40f"}
                                textStyle={{ color: "#555" }}
                                outline
                                onClick={this.closeForm}
                            />
                            <Button
                                text="Salvar"
                                type="submit"
                                // style={{ width: "25%" }}
                                rounded
                                buttonType="primary"
                                textStyle={{ color: "#555" }}
                                outline
                                // animated
                            />
                        </div>
                    </div>
                </Form>
            </div>
        )
    }

    renderManagementCategories = () => {
        return (
            <div style={{display: 'flex', flexDirection: 'column'}}>
                <InputLabel
                    reference={(input) => this.searchInput = input} 
                    inputClass="input--default"
                    placeholder='Nova categoria'
                    meta={{ touched: false, error: false }}
                    input={{
                        name: "test",
                        value: this.state.newCategory,
                        onChange: this.changeNewCategory,
                        onKeyDown: this.handleKeyDowNewCategory
                    }}
                    style={{textAlign: 'left', fontSize: '1.6rem', paddingBottom: 0}}
                    inputStyle={{
                        fontSize: '1.8rem', padding: 20, borderRadius: '1rem', background: '#efefef',
                        borderWidth: 0
                    }}
                    type="text"
                    name="search"
                    icon="fa fa-plus"
                    cols='12 12 12 12'
                    iconRight
                    iconStyle={{ color: '#113950', background: 'transparent'}}
                    iconClick={this.handleAddCategory}
                    />
                <Table
                    data={this.props.categories}
                    rowKey='_id'
                    className="table-modal"
                >
                    {this.renderColumns()}
                </Table>
                <Button
                    text="Fechar"
                    type="button"
                    rounded
                    style={{marginTop: 20}}
                    colors={"#f1c40f"}
                    textStyle={{ color: "#555" }}
                    outline
                    onClick={() => this.setState({ isVisibleCat: false})}
                />
            </div>
        )
    }

    
    render() {
        if (this.props.loading) {
            return <Loading isVisible={this.props.loading} overlay={true} />;
        }

        return (
            <section className="my-charts">

                <div className="my-charts__content-category" style={{marginTop: '2rem'}}>
                    <div className="my-charts__content-category--header">
                        <span className="subtitle--header">Categorias</span>
                        <button className="my-charts__content-category--header-action" onClick={() => this.setState({ isVisibleCat: true })}>
                            <i className="fa fa-pencil" style={{color: 'white', fontSize:22, float: 'right'}}></i>
                        </button>
                    </div>
                    <div className="my-charts__content-category--body">
                        <div style={{display: 'inline-block'}}>
                        <RadioGroup name="categories" value={this.state.category} onChange={this.changeRadio}>
                            {this.renderCategories()}
                        </RadioGroup>
                        </div>
                        
                    </div>
                </div>
                <div className="my-charts__content-charts">
                    {this.renderMyCharts()}
                </div>

                <div className="new-chart" onClick={() => {this.props.initializeForm("myChartsForm", {});this.setState({ isVisible: true, titleModal: 'Novo Mapa'})}}>
                    <div className="fa fa-plus new-chart--icon" />
                    <span className="new-chart--text">Novo Mapa</span>
                </div>
                <DefaultModal
                    id='form'
                    style
                    title={this.state.titleModal}
                    isVisible={this.state.isVisible}
                >
                    {this.renderForm()}
                </DefaultModal>
                <DefaultModal
                    id='form'
                    style
                    title="Gerenciar categorias"
                    isVisible={this.state.isVisibleCat}
                >
                    <div style={{padding:20}}>
                        {this.renderManagementCategories()}
                    </div>
                </DefaultModal>
                <ErrorModal
					isVisible={this.state.errVisible}
					btnCancel={{
						text: 'Cancelar',
						onClick: this.hideDelete
					}}
					btnOk={{
						text: 'Excluir',
						onClick: this.handleDelete
					}}
				/>
            </section>
        );
    }
}

MyCharts = reduxForm({ form: "myChartsForm" })(MyCharts);

const mapStateToProps = state => {
    return {
        auth: state.auth,
        myCharts: state.myChart.list.content,
        loading: state.myChart.loading,
        cities: state.city.list.content,
        categories: state.category.list.content
    };
};
const mapDispatchToProps = dispatch => ({
    ...bindActionCreators(
        {
            reset,
            setLoading,
            getMyCharts,
            drawChart,
            saveChart,
            remove,
            update,
            initializeForm,
            getMyCategories,
            createCategory,
            removeCategory,
            create
        },
        dispatch
    )
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MyCharts);
